<template>
    <Toast />
</template>

<script>
import Toast from 'primevue/toast';
import { useToast } from "primevue/usetoast";
import { onMounted } from 'vue';

export default {
    name: 'tw-toast',
    components: {
        Toast
    },
    props: {
        severity: String,
        message: String,
        lift: Number
    },
    setup(props) {
        const toast = useToast();

        onMounted(() => {
            toast.add({
                severity: props.severity,
                summary: props.message,
                // detail:'Message Content',
                life: props.lift
            });
        })
    }
}
</script>

<style>

</style>